import React from 'react';
import { styled, Media } from 'themes';
import { Img } from 'components';
import { useStaticQuery, graphql } from 'gatsby';
import { useTranslation } from 'react-i18next';

const Informational = () => {
  const [t] = useTranslation();
  const images = useStaticQuery(graphql`
    query {
      kids: imageSharp(
        fluid: { originalName: { regex: "/kids.jpg/" } }
      ) {
        fluid(maxWidth: 640) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
      dog: imageSharp(
        fluid: { originalName: { regex: "/dog.jpg/" } }
      ) {
        fluid(maxWidth: 640) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
  `);

  const informationals = [
    {
      title: t('section--informational.title-1'),
      content: t('section--informational.content-1'),
      image: images.kids,
    },
    {
      title: t('section--informational.title-2'),
      content: t('section--informational.content-2'),
      image: images.dog,
    },
  ];

  return (
    <Section>
      <Informationals>
        {informationals.map((item, i) => {
          return (
            <InformationalItem key={i}>
              <ImageWrapper>
                <Img fluid={item.image.fluid} />
              </ImageWrapper>
              <Content>
                <Title fontWeight="bold" fontSize={[5, 7, 8, 10]}>
                  {item.title}
                </Title>
                <Paragraph>{item.content}</Paragraph>
              </Content>
            </InformationalItem>
          );
        })}
      </Informationals>
    </Section>
  );
};

const Section = styled.div`
  grid-column: center-start / center-end;
`;
const Informationals = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  row-gap: 15px;

  ${Media.tablet} {
    row-gap: 25px;
  }
`;
const InformationalItem = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 15px;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  grid-template-areas: 'Image' 'Content';
  align-items: center;

  &:nth-child(2n) {
    justify-self: end;
  }

  ${Media.tablet} {
    grid-gap: 25px;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    grid-template-areas: 'Image Content';

    &:nth-child(2n) {
      grid-template-areas: 'Content Image';
      justify-self: end;
    }
  }
`;
const ImageWrapper = styled.div`
  grid-area: Image;
`;
const Content = styled.div`
  grid-area: Content;
`;

const Title = styled.h3``;

const Paragraph = styled.p`
  font-size: 1.7rem;
`;

export default Informational;
